import { FormikHelpers } from "formik";
import LineTypeForm from "./LineTypeForm";
import { useGetLineType } from "./api/getLineType";
import { useEditLineType } from "./api/editLineType";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditLineType = ({handleCloseModal, lineTypeId}: EditLineTypeProps)  => {
  const getLineTypeQuery = useGetLineType({lineTypeId: lineTypeId})
  const editLineTypeMutation = useEditLineType({data: {}, lineTypeId});

  const handleSubmit = async (values: IPostEditLineType, { setSubmitting }: FormikHelpers<IPostEditLineType>): Promise<void> => {
    try {
      await editLineTypeMutation.mutateAsync({
        data: values,
        lineTypeId: lineTypeId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getLineTypeQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getLineTypeQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους Γραμμής</div>
    )
  }

  return (
    <>
      {!getLineTypeQuery.isLoading && getLineTypeQuery.data &&
        <LineTypeForm initialValues={getLineTypeQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditLineTypeProps {
  lineTypeId: number;
  handleCloseModal: () => void;
}

export default EditLineType;